<template>
  <div class='cont selector' :class="[{unseenFeed : (mess.fed_type!=='header' && global && mess.unseen==1), hasTask: mess.tsk_id!==null},'msg-'+this.mess.fed_type]"
    :id="mess.fed_id">

    <!-- TIMESTAMP -->
    <div class='new-step' v-if='!global&&mess.fed_islabel!==1' title='Create new bookmark' v-b-modal='"creating-step"'
      @click.stop='selectStep'>
      <i class="fas fa-plus-circle"></i>
    </div>

    <!-- <router-link tag='div' class='routerlink' :to='routeToTask'> -->
    <div class='routerlink' @click='routeToTask2'>

      <!-- AVATAR -->
      <div class='img-placeholder' v-if='mess.fed_islabel!==1'>

        <avatar v-if='this.mess.fed_type==="message"' :username="mess.usr_name +' '+ mess.usr_surname" :src="getAvatar"
          :rounded="false" :size="40" class='avatar'>
        </avatar>
        <i class="fas fa-paperclip" v-if='this.mess.fed_type==="attachment"'></i>
        <i class="fas fa-info-circle" v-if='this.mess.fed_type==="status"'></i>
      </div>

      <!-- FEED TEXT -->
      <div class="message-body" :class='{"header-type": mess.fed_islabel==1}'>
        <div class="message-body-header">
          <span class="name" v-if='mess.fed_islabel!==1'>{{mess.usr_name +' '+ mess.usr_surname}}</span>
          <span class='time-right' v-if='global' :title="mess.pro_name">Project:&nbsp;{{mess.pro_name | filter20Chars}}</span>
          <span class='time-right' v-if='global && mess.tsk_id!==null' :title="mess.tsk_title">Task:&nbsp;
            <router-link tag='a' :to='routeToTask'>{{mess.tsk_title | filter20Chars}}</router-link>
          </span>
          <span class='time-right' v-if='mess.tsk_id===null'> </span>
          <span class='time-right' v-if='mess.fed_islabel!==1' :title='mess.fed_time'>
            <span class='year-date-format' v-if='!isSameYear(mess.fed_time)'>{{ parseYearMoment(mess.fed_time) }}</span>
            <span>
              {{$moment(mess.fed_time).format('MMM Do')}}
            </span>
            <span class='time-date-space'>
              {{$moment(mess.fed_time).format('HH:mm')}}
            </span>
          </span>
        </div>
        <div class="message">
          <a target="_blank" :href='showFile()' v-if="mess.fed_type==='attachment'&&!isImage()" class="attach show">{{mess.fed_text}}</a>
          <vue-simple-markdown :lists='false' :source="mess.fed_text" class="feed-message-block" v-else></vue-simple-markdown>
          <!-- Naslov slike samo u globalnima -->
        </div>
        <img @click.stop='openImage' id='attachment-image' v-if="mess.fed_type==='attachment'&&isImage()" :src="showFile()">
      </div>

      <!-- </router-link> -->
    </div>

    <!-- IMPORTANT MARKER -->
    <i @click.stop='importantFeed' class="fas fa-star" :class="{ important: isImportant }" v-if='mess.fed_islabel!=1'></i>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { baseURL } from "@/api/config.js";
import { store } from "@/store/index.js";
import router from "@/router/index.js";
import { routejs } from "@/router/routemanage.js";
import Avatar from "vue-avatar";

export default {
  components: {
    Avatar
  },
  props: {
    mess: {
      type: Object
    }
  },
  data() {
    return {
      uploadProgress: 0,
      global: false
    };
  },
  computed: {
    ...mapState({
      scrollDownMess: state => state.modulefeed.scrollDownMess, //vraca true ili false u zavisnosit da li treba spustiti scroll
      user: state => state.userStorage
    }),
    ...mapGetters({
      taskid: "selectedItemID"
    }),
    isImportant() {
      return this.mess.fed_important;
    },
    getAvatar() {
      let netIcon = "";
      if (this.mess.usrimg !== undefined && this.mess.usrimg !== null) {
        netIcon = baseURL + this.mess.usrimg + "?sid=" + localStorage.sid;
      }
      return netIcon;
    },
    routeToTask() {
      let taskID = this.mess.tsk_id;
      if (taskID === undefined || taskID === null) {
        return "";
      }
      return `/tasks/${taskID}`;
    }
  },
  methods: {
    routeToTask2() {
      let taskID = this.mess.tsk_id;
      if (taskID !== undefined && taskID !== null) {
        router.push(`/tasks/${taskID}`);
      }
    },
    selectStep() {
      store.commit("setSelectedStep", this.mess);
    },
    importantFeed() {
      store.commit("changeImportant", {
        mess: this.mess
      });
    },
    openImage() {
      window.open(this.showFile());
    },
    isImage() {
      if (!this.mess.fed_text || this.mess.fed_text == null) return false;
      var extension = this.mess.fed_text
        .replace(/.+([.].+)/i, "$1")
        .toLowerCase();
      let extTypes = ["jpg", "jpeg", "png", "gif", "webp"];
      return extTypes.includes(extension.replace(".", ""));
    },
    mojaPoruka() {
      if (
        this.name == this.mess.usr_name &&
        this.surname == this.mess.usr_surname
      )
        return true;
      else return false;
    },
    showFile() {
      let sid = localStorage.sid;
      let fid = this.mess.fed_id;
      return `${baseURL}tasks/${this.taskid}/feeds/${fid}?sid=${sid}`;
    }
  },
  mounted() {
    if (this.scrollDownMess) {
      var id = document.getElementById("all");
      if (id !== undefined && id !== null) id.scrollTop = id.scrollHeight;
    }
  }
};
</script>

<style scoped>
.feed-message-block {
  display: block;
  /* font-size: 14px; */
  margin-top: 10px;
}

.header-type {
  font-size: 200%;
  text-align: center;
}

.new-step {
  color: #007bff;
  cursor: pointer;
  margin: 15px 15px 15px 5px;
  align-self: center;
}

.important {
  color: #199686 !important;
}

.cont .fa-star {
  color: lightgray;
  font-size: 110%;
  padding: 5px;
  cursor: pointer;
}

.cont {
  display: flex;
  padding: 5px 10px;
}

.cont:not(:last-child) {
  border-bottom: 1px solid rgba(102, 144, 222, 0.169);
}

.cont:nth-child(odd) {
  background: rgba(136, 136, 136, 0.03);
}

.img-placeholder {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin: 5px 0 0 0;
}

.img-placeholder i {
  font-size: 150%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto 0;
  padding: auto;
}

.img-placeholder i.fa-info-circle {
  color: var(--ac-color);
}

.img-placeholder i.fa-paperclip {
  color: #6c7284;
}

.cont .name {
  font-size: 12px;
  font-weight: bold;
  color: var(--ac-color);
  flex: 1;
}

.unseenFeed .new-step,
.unseenFeed.cont .name {
  color: #439eff;
}

.cont .attach {
  color: #139cbf;
}

#attachment-image {
  height: initial;
  max-width: 60%;
  border-radius: 5px;
  cursor: pointer;
}

.message {
  white-space: pre-line;
  word-wrap: break-word;
  font-size: 90%;
}

.message a {
  display: block;
  margin-top: 3px;
}

.message-body {
  margin: 0 10px;
  flex: 1;
}

.message-body-header {
  display: flex;
  justify-content: space-between;
}

.right-con {
  margin: 0 10px;
  display: flex;
}

.right-con .message-body-header {
  flex-direction: row-reverse;
}

.cont::after {
  content: "";
  clear: both;
  display: table;
}

.time-right {
  color: #8a8a8a;
  font-size: 12px;
  flex: 1;
  /* text-align: left; */
  margin-right: 5px;
}

.time-right:last-child {
  text-align: right;
  flex: none;
}

.selector p {
  display: inline;
  text-align: left;
}

.selector .routerlink {
  display: flex;
  width: 100%;
  padding: 8px 0;
}

.feed-global .hasTask .routerlink {
  cursor: pointer;
}

.feed-global .hasTask:hover .routerlink {
  transition: 0.5s ease;
  background-color: rgba(76, 74, 74, 0.03);
  border-radius: 0.5rem;
}

.progress {
  margin: 0 auto;
  position: relative;
  width: 90%;
  height: 20px;
  border: 2px solid #ccc;
  border-radius: 5px;
}

.progress p {
  position: absolute;
  text-align: center;
  width: 100%;
  font-size: 12px;
}

.progress .in-progress {
  background-color: #0a0;
  height: 100%;
  width: 0;
}

.unseenFeed {
  border-left: 6px solid #ecec14;
  background: rgba(255, 237, 0, 0.48) !important;
}

.darkTheme .unseenFeed {
  background: rgba(255, 237, 0, 0.15) !important;
}

.darkTheme .unseenFeed span.time-right {
  color: white;
}

.msg-status .message {
  font-size: 78%;
  font-weight: bold;
}

.vue-avatar--wrapper.avatar {
  font: 20px Saira !important;
}

.avatar {
  border-radius: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Feed/FeedMessage.vue